<template>
    <div class="filters-container">
        <div class="row g-3 align-items-end">
            <div class="col-lg-5 col-md-6">
                <label for="searchLonja" class="form-label fw-semibold">
                    <i class="fas fa-search text-secondary me-1"></i>
                    Buscar por nombre
                </label>
                <SoftInput
                    size="sm"
                    id="searchLonja"
                    :value="search"
                    @update:value="$emit('update:search', $event)"
                    placeholder="Nombre de la lonja..."
                />
            </div>

            <div class="col-lg-3 col-md-6">
                <label class="form-label fw-semibold d-block">
                    <i class="fas fa-toggle-on text-secondary me-1"></i>
                    Estado
                </label>
                <div class="form-check form-switch m-0">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="onlyActiveSwitch"
                        :checked="onlyActive"
                        @change="$emit('update:onlyActive', $event.target.checked)"
                    />
                    <label class="form-check-label text-sm" for="onlyActiveSwitch">
                        Solo activas
                    </label>
                </div>
            </div>
        </div>

        <div class="actions-row">
            <div class="d-flex gap-2 flex-wrap align-items-center">
                <SoftButton color="primary" size="sm" variant="gradient" @click="$emit('search')">
                    <i class="fas fa-search me-1"></i>
                    Buscar
                </SoftButton>

                <SoftButton color="secondary" size="sm" variant="outline" @click="$emit('clear')">
                    <i class="fas fa-broom me-1"></i>
                    Limpiar
                </SoftButton>

                <SoftButton color="secondary" size="sm" variant="outline" @click="$emit('refresh')">
                    <i class="fas fa-sync-alt me-1"></i>
                    Actualizar
                </SoftButton>

                <span v-if="hasActiveFilters" class="badge bg-primary bg-gradient ms-2">
                    <i class="fas fa-filter me-1"></i>
                    {{ activeFiltersCount }} filtro{{ activeFiltersCount > 1 ? 's' : '' }}
                </span>

                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import SoftInput from '@/components/SoftInput.vue';
import SoftButton from '@/components/SoftButton.vue';

export default {
    name: 'FiltersLonja',
    components: { SoftInput, SoftButton },
    props: {
        search: { type: String, default: null },
        onlyActive: { type: Boolean, default: false }
    },
    emits: ['update:search', 'update:onlyActive', 'search', 'clear', 'refresh'],
    computed: {
        hasActiveFilters() {
            return !!this.search || this.onlyActive;
        },
        activeFiltersCount() {
            let count = 0;
            if (this.search) count++;
            if (this.onlyActive) count++;
            return count;
        }
    }
};
</script>

<style lang="scss" scoped>
.filters-container {
    background: #f8f9fa;
    border-radius: 0.75rem;
    padding: 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid #e9ecef;

    .form-label {
        margin-bottom: 0.4rem;
        color: #344767;
        font-size: 0.8rem;
    }
}

.form-check-input:checked {
    background-color: #E53935;
    border-color: #E53935;
}

.actions-row {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #e9ecef;
}
</style>
